// import { getAccessToken } from "config/token";
// import { NEXUS_API_BASE_URL } from "const";
// import { useMsal, IMsalContext } from "@azure/msal-react";
// import axios from "axios";
// import { AxiosResponse } from "axios";
// import { $bucketUrlHost, $datazoneUrlHost } from "../../http/index";
// import { Credentials } from "../../components/Users/components/AccessData/types";
// import { getHeaders } from "../../helpers";
// import { S3Client, ListObjectsV2Command, ListBucketsCommand, ListObjectsCommand, ListObjectsCommandOutput } from "@aws-sdk/client-s3";
// import { IDomainsConfig } from "pages/Ponds/types";
// import {
//   IPublicClientApplication,
//   PublicClientApplication,
// } from "@azure/msal-browser";
// // import { msalConfig } from "./config/auth";

// // credential names for storage:
// const tokenKeys = {
//   s3AwsKeyId: "S3-AWS-Key-Id",
//   s3AwsSecretKey: "S3-AWS-Secret-Key",
//   s3AwsCredsType: "S3-AWS-Creds-Type",
//   s3AwsExpirationTimestamp: "S3-AWS-Expiration-Timestamp",
//   msalAccountKeys: "msal.account.keys",
// };
// interface AwsSession {
//   AccessKeyId: string;
//   SecretAccessKey: string;
//   SessionToken?: string;
//   region: string;
// }

// interface AwsCredentials {
//   accessKeyId: string;
//   secretAccessKey: string;
//   sessionToken?: string;
//   region: string;
// }

// const extractAwsCredentials = (session: AwsSession, region_name:string): AwsCredentials => ({
//   accessKeyId: session.AccessKeyId,
//   secretAccessKey: session.SecretAccessKey,
//   sessionToken: session.SessionToken,
//   region: region_name,
// });

// export const fetchAwsCredentials = async (
//   msalInstance: IMsalContext,
//   bucket_name: string,
// ): Promise<AwsCredentials | null> => {
//   try {
//     const token = await getAccessToken(msalInstance);
//     const _headers = getHeaders(token?.token);
//     const headers = {
//       Authorization: _headers.Authorization,
//       "Content-Type": _headers["Content-Type"],
//     };

//     const response: AxiosResponse<{
//       region_name: any; data: { session: AwsSession }
// }> =
//       await $datazoneUrlHost.get(`v2/s3buckets/${bucket_name}/keys`, {
//         headers,
//       });

//     const session = response.data.data.session;
//      const region_name = response.data.region_name;
//     return extractAwsCredentials(session, region_name);
//   } catch (error) {
//     console.error("Failed to fetch AWS credentials:", error);
//     return null;
//   }
// };


 // src/services/awsCredentials.ts

import { getAccessToken } from "config/token";
import { useMsal, IMsalContext } from "@azure/msal-react";
import { Credentials } from "../Users/components/AccessData/types";
import { loadAwsSession } from "../../utils/awsSession";

/**
 * Shape of the AWS session as stored/decrypted.
 */
interface AwsSession extends Credentials {
  SessionToken?: string;
  region?: string;
}

/**
 * Normalized credentials for AWS SDK clients.
 */
export interface AwsCredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken?: string;
  region: string;
}

/**
 * Extracts the fields we need from the decrypted session.
 */
const extractAwsCredentials = (
  session: AwsSession,
  defaultRegion = "us-east-1",
): AwsCredentials => ({
  accessKeyId: session.AccessKeyId,
  secretAccessKey: session.SecretAccessKey,
  sessionToken: session.SessionToken,
  region: session.region ?? defaultRegion,
});

/**
 * Instead of calling the /keys API, decrypts the previously
 * stored AWS session from localStorage. Console.logs the
 * decrypted object, and returns the normalized credentials.
 *
 * Throws if no session is found or it’s expired.
 */
export const fetchAwsCredentials = async (
  msalInstance: IMsalContext,
  bucketName: string,
): Promise<AwsCredentials> => {
  // We ignore msalInstance and bucketName here,
  // because credentials are loaded from localStorage.
  const session = await loadAwsSession();
  console.log("Decrypted AWS session:", session);
  return extractAwsCredentials(session);
};
